import React from 'react';
import { Box, Text, TableCell, TableRow, Link, Badge } from '@razorpay/blade/components';
import { EmployeeTableNode } from '../types';
import { routePaths } from 'components/Routes/data';
import { employmentTypeNotApplicableLabel, getEmploymentTypeBadge } from '../utils';

export const EmployeeTableRow = ({
  employee,
  showEmploymentType = false,
}: {
  employee: EmployeeTableNode;
  showEmploymentType?: boolean;
}) => {
  const employmentTypeBadge = getEmploymentTypeBadge(employee.employeeSubType);
  return (
    <TableRow key={employee.id} item={employee} hoverActions={employee.rowHoverAction}>
      <TableCell>
        <Box display="flex" flexDirection="column">
          {employee.peopleId ? (
            <Link href={`${routePaths.employeeDetails.root}${employee.peopleId}`}>
              {employee.name}
            </Link>
          ) : (
            <Text weight="regular" color="surface.text.gray.normal">
              {employee.name}
            </Text>
          )}
          {!!employee.employeeId && (
            <Text size="small" color="surface.text.gray.muted">
              {employee.employeeId}
            </Text>
          )}
        </Box>
      </TableCell>

      {showEmploymentType && (
        <TableCell>
          {employmentTypeBadge ? (
            <Badge color={employmentTypeBadge.color}>{employmentTypeBadge.label}</Badge>
          ) : (
            <Text color="surface.text.gray.muted">{employmentTypeNotApplicableLabel}</Text>
          )}
        </TableCell>
      )}

      <TableCell>
        <Text color="surface.text.gray.normal">{employee.designation}</Text>
      </TableCell>

      <TableCell>
        <Text color="surface.text.gray.normal">{employee.department}</Text>
      </TableCell>
    </TableRow>
  );
};
